import React, { useEffect, useState } from "react";
import { useAccessibility } from "./AccessibilityContext";
import "./accessibilityTopBar.css";
import { useNavigate } from "react-router-dom";

export default function AccessibilityTopBar() {
  const {
    fontScale,
    setFontScale,
    contrast,
    setContrast,
    brightness,
    setBrightness,
    resetAccessibility,
  } = useAccessibility();

  const [currentTime, setCurrentTime] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleString("en-IN", {
          weekday: "short",
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  // multiple contrast levels
  const contrastLevels = [100, 125, 150, 175, 200];
  const brightnessLevels = [1, 1.1, 1.2, 1.3, 1.4];

  const increaseContrast = () => {
    const index = contrastLevels.indexOf(contrast);
    const nextIndex = (index + 1) % contrastLevels.length;
    setContrast(contrastLevels[nextIndex]);
  };

  const increaseBrightness = () => {
    const index = brightnessLevels.indexOf(brightness);
    const nextIndex = (index + 1) % brightnessLevels.length;
    setBrightness(brightnessLevels[nextIndex]);
  };

  const handleHomePageNavaigation = () => {
    navigate("/");
  };

  return (
    <div className="a11y-topbar">
      <div className="a11y-left">
        <a href='/' className="skip-link">
          Skip to main content
        </a>
        <span className="time-display">{currentTime}</span>
      </div>

      <div className="a11y-right">
        <button onClick={() => setFontScale(Math.max(1, fontScale - 0.25))}>
          A-
        </button>

        <button onClick={() => setFontScale(Math.min(4, fontScale + 0.25))}>
          A+
        </button>

        <button onClick={increaseContrast}>
          Contrast ({contrast}%)
        </button>

        <button onClick={increaseBrightness}>
          Brightness ({Math.round(brightness * 100)}%)
        </button>

        <button onClick={resetAccessibility}>Reset</button>
      </div>
    </div>
  );
}